import React from 'react';

const ZoomBtn = ({ cy }) => {
  function zoom(level) {
    const zoomLevel = Math.round(level * 4) / 4;
    cy.zoom(zoomLevel);
    $('#zoomLevel').text(zoomLevel);
  }

  const onZoomOut = () => {
    const zoomLevel = cy.zoom();
    if (zoomLevel > 0.35) {
      zoom(zoomLevel - 0.25);
    }
    highlight(this);
  };

  const onZoomIn = () => {
    const zoomLevel = cy.zoom();
    if (zoomLevel <= 2.25) {
      zoom(zoomLevel + 0.25);
    }
    highlight(this);
  };

  function highlight(obj) {
    // debug-console.log(obj);
    $(obj)
      .animate(
        {
          'border-color': '#777',
          'border-width': '2px',
        },
        50,
      )
      .animate(
        {
          'border-color': '',
          'border-width': '0px',
        },
        50,
      );
  }
  
  return (
    <div id="zoom">
      <input
        id="zoom-out"
        type="submit"
        className="btn"
        value="-"
        data-bs-toggle="tooltip"
        data-bs-placement="top"
        title="Thu nhỏ Sơ đồ"
        onClick={onZoomOut}
      />
      <div>
        <span>Zoom</span>
        <br />
        <span id="zoomLevel">0.5</span>
      </div>
      <input
        id="zoom-in"
        type="submit"
        className="btn"
        value="+"
        data-bs-toggle="tooltip"
        data-bs-placement="top"
        title="Phóng to Sơ đồ"
        onClick={onZoomIn}
      />
    </div>
  );
};
export default ZoomBtn;
